import { IntegrationDetailModel } from "./IntegrationDetail.model";

export class IntegrationDetail extends IntegrationDetailModel {
    // Add custom methods here
}
